import QuoteBlockSection from './quote-block-section';

export default QuoteBlockSection;
